import { Button, Tooltip } from '@heroui/react';
import { Compress, ExpandLines } from 'iconoir-react';

import i18n from '~/common/helpers/i18n';

type ExecutionLogsExpandCollapseButtonsProps = {
  onExpandAll: () => void;
  onCollapseAll: () => void;
  disabled?: boolean;
};

export function ExecutionLogsExpandCollapseButtons({
  onExpandAll,
  onCollapseAll,
  disabled = false
}: ExecutionLogsExpandCollapseButtonsProps) {
  const expandLabel = i18n.t('scenes.monitor.agentLogs.details.expandAllLogs');
  const collapseLabel = i18n.t(
    'scenes.monitor.agentLogs.details.collapseAllLogs'
  );

  return (
    <div
      className='flex justify-end gap-2 py-2'
      data-testid='monitor-agent-logs-details-logs-quick-actions'
    >
      <Tooltip content={expandLabel}>
        <Button
          isIconOnly
          size='sm'
          variant='flat'
          className='min-w-7 bg-surface-dim text-on-surface'
          onPress={onExpandAll}
          isDisabled={disabled}
          aria-label={expandLabel}
          data-testid='monitor-agent-logs-details-expand-all-logs'
        >
          <ExpandLines className='icon-smallest' />
        </Button>
      </Tooltip>
      <Tooltip content={collapseLabel}>
        <Button
          isIconOnly
          size='sm'
          variant='flat'
          className='min-w-7 bg-surface-dim text-on-surface'
          onPress={onCollapseAll}
          isDisabled={disabled}
          aria-label={collapseLabel}
          data-testid='monitor-agent-logs-details-collapse-all-logs'
        >
          <Compress className='icon-smallest' />
        </Button>
      </Tooltip>
    </div>
  );
}
